// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { LATEST_NOTIFICATION, GET_ALL_NOTIFICATION, MARK_ALL_NOTIFICATION_READ, NOTIFICATION_DELETE, LOGOUT } from '../../../../../common/constant'
import { get, post } from '../../../../../common/api'


export const actionLatestNotification = createAsyncThunk('NotificationStore/actionLatestNotification', async (params, thunkAPI) => {
    return await get(LATEST_NOTIFICATION, params, thunkAPI)
})


export const actionGetAllNotification = createAsyncThunk('NotificationStore/actionGetAllNotification', async (params, thunkAPI) => {
    return await get(GET_ALL_NOTIFICATION, params, thunkAPI)
})

export const actionMarkAllNotificationRead = createAsyncThunk('NotificationStore/actionMarkAllNotificationRead', async (params, thunkAPI) => {
    return await get(MARK_ALL_NOTIFICATION_READ, params, thunkAPI)
})

export const actionNotificationDelete = createAsyncThunk('NotificationStore/actionNotificationDelete', async (params, thunkAPI) => {
    return await post(NOTIFICATION_DELETE, params, thunkAPI)
})

export const actionLogout = createAsyncThunk('NotificationStore/actionLogout', async (params, thunkAPI) => {
    return await get(LOGOUT, params, thunkAPI)
})

export const notificationSlice = createSlice({
    name: 'NotificationStore',

    initialState: {

        //latest notification list
        loadingLatestNotification: false,
        latestNotification: null,

        //all notification list
        loadingGetAllNotification: false,
        getAllNotification: null,

        //mark all notification read
        loadingMarkAllNotification: false,
        markAllNotification: null,

        //notification delete
        loadingNotificationDelete: false,
        notificationDelete: null,

        // logout
        loadingLogout: false,
        logout: null,



    },
    reducers: {
        //reset or delete public store data
        resetLatestNotification: (state) => {
            state.latestNotification = null
        },

        resetGetAllNotification: (state) => {
            state.getAllNotification = null
        },

        resetMarkAllNotification: (state) => {
            state.markAllNotification = null
        },

        resetNotificationDelete: (state) => {
            state.notificationDelete = null
        },

        resetLogout: (state) => {
            state.logout = null
        },
    },
    extraReducers: builder => {
        builder
            //latest notification
            .addCase(actionLatestNotification.pending, (state) => {
                state.loadingLatestNotification = true
            })
            .addCase(actionLatestNotification.fulfilled, (state, action) => {
                state.loadingLatestNotification = true
                state.latestNotification = action.payload
            })
            .addCase(actionLatestNotification.rejected, (state) => {
                state.loadingLatestNotification = false
            })

            //all notification

            .addCase(actionGetAllNotification.pending, (state) => {
                state.loadingGetAllNotification = true
            })
            .addCase(actionGetAllNotification.fulfilled, (state, action) => {
                state.loadingGetAllNotification = true
                state.getAllNotification = action.payload
            })
            .addCase(actionGetAllNotification.rejected, (state) => {
                state.loadingGetAllNotification = false
            })

            //mark all notification

            .addCase(actionMarkAllNotificationRead.pending, (state) => {
                state.loadingMarkAllNotification = true
            })
            .addCase(actionMarkAllNotificationRead.fulfilled, (state, action) => {
                state.loadingGetAllNotification = true
                state.loadingMarkAllNotification = action.payload
            })
            .addCase(actionMarkAllNotificationRead.rejected, (state) => {
                state.loadingMarkAllNotification = false
            })

            //notification delete

            .addCase(actionNotificationDelete.pending, (state) => {
                state.loadingNotificationDelete = true
            })
            .addCase(actionNotificationDelete.fulfilled, (state, action) => {
                state.loadingNotificationDelete = true
                state.notificationDelete = action.payload
            })
            .addCase(actionNotificationDelete.rejected, (state) => {
                state.loadingNotificationDelete = false
            })

            // logout

            .addCase(actionLogout.pending, (state) => {
                state.loadingLogout = true
            })
            .addCase(actionLogout.fulfilled, (state, action) => {
                state.loadingLogout = true
                state.logout = action.payload
            })
            .addCase(actionLogout.rejected, (state) => {
                state.loadingLogout = false
            })


    }
})
export const { resetLatestNotification, resetGetAllNotification, resetMarkAllNotification, resetLogout, resetNotificationDelete } = notificationSlice.actions

export default notificationSlice.reducer